// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__1u9nJ","fileBtn":"File_fileBtn__31kV3","closeBtn":"File_closeBtn__SSJf2","fileSelected":"File_fileSelected__3mJeN","disabled":"File_disabled__10oaR"};